
import { Component } from "react";
import { message } from 'antd'


class Template extends Component {
  // /**
  // * Creates New Template
  // *
  // * @class
  // * @typedef {import('../../context-reducers/context-reducer').UiStoreType} demoData
  // * @param {demoData} templateObj - Initial state of template with default values
  // */
  constructor(props) {
    super(props)
    this.props = props;
    this.templateObj = {
      title: undefined,
      active: true,
      keywords: undefined,
      properties: undefined,
      rows: [{
        addColumns: true,
        columns: [{
          addSection: true,
          sections: [{
            isEditing: true,
            // sectionTitle:'Section-1',
            questions: []
          }]
        }]
      }]
    }
  }

  isTemplateValidated() {  
    if (this.templateObj.title == undefined || this.templateObj.title == null) {
      return false
    }
  }

  returnSnapshot() {
    return this.templateObj.toString()
  }

  isTemplateEmpty() {
    return this.templateObj == null || this.templateObj == undefined
  }

  toString() {
    return this.templateObj.toString()
  }

/**
 * 
 * @param {String} title - Title of template
 */
  updateTitle(title) {
    this.templateObj.title = title;
  }

/**
 * 
 * @param {Boolean} flag - Flag to tell if the template is active or inactive
 */
  updateActiveStatus(flag) {
    this.templateObj.active = flag;
  }

/**
 * 
 * @param {Array} keywords - Tags attached to the template
 */
  updateKeywords(keywords) {
    this.templateObj.keywords = keywords;
  }

/**
 * 
 * @param {Object} properties - Template properties
 */
  updateProperties(properties) {
    this.templateObj.properties = properties;
  }

/**
 * 
 * @param {String} val - Row title
 * @param {Number} rowIndex - Row index of which title will be updated
 */
  updateRowTitle(val, rowIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];
    if (rowItem) {
      rowItem.title = val
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {String} val - Column title
 * @param {Number} colIndex - Column index of which title will be updated
 * @param {Number} rowIndex - Parent Row index of which title will be updated
 */
  updateColumnTitle(val, colIndex, rowIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];
    let columns = rowItem.columns;
    let columnItem = columns[colIndex];
    if (columnItem) {
      columnItem.title = val
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {String} val - Section title
 * @param {Number} secIndex - Section index of which title will be updated
 * @param {Number} colIndex - Parent Column index of which title will be updated
 * @param {Number} rowIndex - Parent row index of which title will be updated
 */
  updateSectionTitle(val, secIndex, colIndex, rowIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];
    let columns = rowItem.columns;
    let columnItem = columns[colIndex];
    if (columnItem) {
      let sectionItem = columnItem.sections[secIndex];
      if (sectionItem) {
        sectionItem.title = val
      }
    }
    this.templateObj = obj;
  }

  /**
   * Attach conditions to show/hide a Row title
   * @param {Number} rowIndex
   * @param {Array} conditions
   */
  bindConditionsToRowTitle(rowIndex, conditions) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    if (rows[rowIndex]) {
      rows[rowIndex].titleConditions = conditions;
    }
    this.templateObj = obj;
  }

  /**
   * Remove conditions from a Row title
   * @param {Number} rowIndex
   */
  deleteRowTitleConditions(rowIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    if (rows[rowIndex] && rows[rowIndex].titleConditions) {
      delete rows[rowIndex].titleConditions;
    }
    this.templateObj = obj;
  }

  /**
   * Attach conditions to show/hide a Column title
   * @param {Number} rowIndex
   * @param {Number} colIndex
   * @param {Array} conditions
   */
  bindConditionsToColTitle(rowIndex, colIndex, conditions) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];
    if (rowItem && rowItem.columns && rowItem.columns[colIndex]) {
      rowItem.columns[colIndex].titleConditions = conditions;
    }
    this.templateObj = obj;
  }

  /**
   * Remove conditions from a Column title
   * @param {Number} rowIndex
   * @param {Number} colIndex
   */
  deleteColTitleConditions(rowIndex, colIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];
    if (rowItem && rowItem.columns && rowItem.columns[colIndex] && rowItem.columns[colIndex].titleConditions) {
      delete rowItem.columns[colIndex].titleConditions;
    }
    this.templateObj = obj;
  }

  /**
   * Attach conditions to show/hide a Section title
   * @param {Number} rowIndex
   * @param {Number} colIndex
   * @param {Number} secIndex
   * @param {Array} conditions
   */
  bindConditionsToSecTitle(rowIndex, colIndex, secIndex, conditions) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];
    if (rowItem && rowItem.columns && rowItem.columns[colIndex] && rowItem.columns[colIndex].sections && rowItem.columns[colIndex].sections[secIndex]) {
      rowItem.columns[colIndex].sections[secIndex].titleConditions = conditions;
    }
    this.templateObj = obj;
  }

  /**
   * Remove conditions from a Section title
   * @param {Number} rowIndex
   * @param {Number} colIndex
   * @param {Number} secIndex
   */
  deleteSecTitleConditions(rowIndex, colIndex, secIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];
    if (rowItem && rowItem.columns && rowItem.columns[colIndex] && rowItem.columns[colIndex].sections && rowItem.columns[colIndex].sections[secIndex] && rowItem.columns[colIndex].sections[secIndex].titleConditions) {
      delete rowItem.columns[colIndex].sections[secIndex].titleConditions;
    }
    this.templateObj = obj;
  }

  returnTemplate() {
    return this.templateObj;
  }

/**
 * 
 * @param {Object} data - Template object
 */
  updateLocalTemplate(data) {
    this.templateObj = { ...data };
  }

  addNewRow() {
    let obj = { ...this.templateObj };

    obj.rows.map((rowItem) => {
      rowItem.addColumns = false;
      rowItem.columns.map((colItem) => {
        colItem.addSection = false;
        colItem.sections.map((a) => {
          a.isEditing = false;
        })
      })
    })

    obj.rows.push({
      addColumns: true,
      columns: [{
        addSection: true,
        sections: [{
          isEditing: true,
          questions: []
        }]
      }]
    })
    this.templateObj = obj;
  }

  addNewColumn() {
    let obj = { ...this.templateObj };

    obj.rows.map((rowItem) => {
      if (rowItem.addColumns == true) {
        rowItem.columns.map((colItem) => {
          colItem.addSection = false;
          colItem.sections.map((a) => {
            a.isEditing = false;
          })
        })

        rowItem.columns.push({
          addSection: true,
          sections: [{
            questions: [],
            isEditing: true
          }]
        })

      }
    })
    this.templateObj = obj;
  }

  addNewSection() {
    let obj = { ...this.templateObj };
    obj.rows.map((rowItem) => {
      if (rowItem.addColumns == true) {
        rowItem.columns.map((colItem) => {
          if (colItem.addSection == true) {
            colItem.sections.map((a) => {
              a.isEditing = false;
            })
            colItem.sections.push({
              // title: 'Section 2',
              questions: [],
              isEditing: true
            })
          }
        })
      }
    })
    this.templateObj = obj;
  }

/**
 * 
 * @param {Number} rowIndex - Index of row to be deleted
 */
  deleteRow(rowIndex){
    let obj = { ...this.templateObj };
    let rows = obj.rows;

    if(rows[rowIndex].pageProperties && rows[rowIndex].pageProperties.pageBreak == true){
      if(rows[rowIndex-1]){
        rows[rowIndex-1].pageProperties = rows[rowIndex-1].pageProperties ? rows[rowIndex-1].pageProperties : {}
        rows[rowIndex-1].pageProperties.pageBreak = true;
      }else{
        rows.splice(rowIndex, 1)
      }
    }else{
      rows.splice(rowIndex, 1)
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {Number} x - Section index of the section to be deleted
 * @param {Number} rowIndex - Parent row index of the row to be deleted
 * @param {Number} colIndex - Column index of the column to be deleted
 */
  deleteSection(x, rowIndex, colIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];

    let columns = rowItem.columns;
    let columnItem = columns[colIndex];

    if (columnItem.sections.length > 1) {
      columnItem.sections.splice(x, 1);
    } else {
      if (rowItem.columns.length > 1) {
        rowItem.columns.splice(colIndex, 1)
      } else {
        this.deleteRow(rowIndex)
        // columnItem.sections.splice(x, 1);
        // columnItem.sections.push({
        //   isEditing: true,
        //   questions: []
        // })
      }
      // rowItem.columns.splice(colIndex,1)
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {Number} colIndex - Column index of the column to be deleted
 * @param {Number} rowIndex - Parent Row index of the column to be deleted
 */
  deleteColumn(colIndex, rowIndex) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;
    let rowItem = rows[rowIndex];

    if (rowItem && rowItem.columns.length > 1 && rowItem.columns[colIndex]) {
      rowItem && rowItem.columns.splice(colIndex, 1)
    } else if (rowItem && rowItem.columns.length == 1 && rowItem.columns[colIndex]) {
      // rows.splice(rowIndex, 1)
      this.deleteRow(rowIndex)
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {Number} rowIndex - Parent Row Index of question to be deleted
 * @param {Number} colIndex - Parent Column Index of question to be deleted
 * @param {Number} secIndex - Parent Section Index of question to be deleted
 * @param {Number} quesIndex - Question Index of question to be deleted
 * @param {Number} linkedIndex - Deprecated
 * @param {Object} quesItem - Object of question to be deleted
 */
  deleteQuestion(rowIndex, colIndex, secIndex, quesIndex, linkedIndex, quesItem) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;

    const loopQuestions = (a, index, arr) => {

      if (a && a != null) {
        if (a.slugValue == quesItem.slugValue) {
          arr.splice(index, 1)
        } else {
          if (a.linkedQuestions && a.linkedQuestions.length > 0) {
            a.linkedQuestions.map((param, m) => {
              loopQuestions(param, m, a.linkedQuestions)
            })
          }
        }
      }
    }

    let rowItem = rows[rowIndex];
    if (rowItem) {

      let columns = rowItem.columns;
      let columnItem = columns[colIndex];
      if (columnItem) {
        let sectionItem = columnItem.sections[secIndex];
        if (sectionItem) {
          let quesArr = sectionItem.questions;

          if (linkedIndex == undefined) {
            quesArr.splice(quesIndex, 1)
          } else {

            let ques = quesArr[quesIndex];
            if (ques && ques.linkedQuestions) {
              let aa = ques.linkedQuestions;
              ques.linkedQuestions.map((param, m) => {
                loopQuestions(param, m, aa)
              })

            }

          }
        }
      }
    }

    this.templateObj = obj;

  }

/**
 * 
 * @param {Object} sectionItem - Object of section to be deleted
 * @param {Number} x - Index of section to be deleted
 * @param {Number} colIndex - Index of column to be deleted
 * @param {Number} rowIndex - Index of row to be deleted
 */
  updateSectionIsEditingStatus(sectionItem, x, colIndex, rowIndex) {
    let obj = { ...this.templateObj };
    const loopQuestion = (a) => {
      if (a && a != null) {
        a.isLinking = false;
        if (a.linkedQuestions && a.linkedQuestions.length > 0) {
          a.linkedQuestions.map((param) => {
            loopQuestion(param)
          })
        }
      }
    }

    obj.rows.map((rowItem, m) => {

      if (rowIndex == m) {
        rowItem.addColumns = true;
      } else {
        rowItem.addColumns = false;
      }
      rowItem.columns.map((colItem, y) => {

        if (colIndex == y && rowIndex == m) {
          colItem.addSection = true;
        } else {
          colItem.addSection = false;
        }
        colItem.sections.map((item, i) => {
          if (colIndex == y && m == rowIndex && i == x) {
            item.isEditing = true;
          } else {
            item.isEditing = false;
          }
          item.questions && item.questions.map((a) => {
            loopQuestion(a)
          })
        })
      })
    })

    this.templateObj = obj;
  }

/**
 * 
 * @param {Object} quesItem - Object of question to be deleted
 */
  updateQuestionLinkingFlag(quesItem) {
    let obj = { ...this.templateObj };
    const unflagBelowTree = (a) => {

      a.isLinking = false;
      if (a.linkedQuestions && a.linkedQuestions.length > 0) {
        a.linkedQuestions.map((param) => {
          unflagBelowTree(param)
        })
      }
    }

    const loopQuestion = (a) => {
      if (a && a != null) {
        if (a.slugValue == quesItem.slugValue) {
          a.isLinking = !a.isLinking;

          if (a.linkedQuestions && a.linkedQuestions.length > 0) {
            a.linkedQuestions.map((param) => {
              unflagBelowTree(param)
            })
          }

          return true
        } else {
          let flag = false;
          a.isLinking = false;

          if (a.linkedQuestions && a.linkedQuestions.length > 0) {
            a.linkedQuestions.map((param) => {
              let flag1 = loopQuestion(param)
              if (flag1) {
                flag = flag1
              }
            })
            return flag
          }
        }
      }
    }
    obj.rows.map((rowItem) => {
      rowItem.columns.map((colItem) => {
        colItem.sections.map((item) => {
          let flag = false;
          item.questions && item.questions.map((a) => {
            let flag1 = loopQuestion(a)
            if (flag1) {
              flag = flag1
            }
          })
          item.isEditing = flag
        })
      })
    })
    this.templateObj = obj;
  }

  setPageBreak() {
    let obj = { ...this.templateObj };
    // let pageBreak = obj.rows.lastIndexOf((a)=>a.pageProperties && a.pageProperties.pageBreak == true);
    // const pageBreak = obj.rows.filter((a) => a.pageProperties && a.pageProperties.isFooter != true).map(a => a.pageProperties && a.pageProperties.pageBreak).lastIndexOf(true);

    obj.rows.map((rowItem) => {
      rowItem.addColumns = false;
      rowItem.columns.map((colItem) => {
        colItem.addSection = false;
        colItem.sections.map((a) => {
          a.isEditing = false;
        })
      })
    })
    obj.rows[obj.rows.length - 1].pageProperties = obj.rows[obj.rows.length - 1].pageProperties ? obj.rows[obj.rows.length - 1].pageProperties : {};
    obj.rows[obj.rows.length - 1].pageProperties.pageBreak = true;

      obj.rows[obj.rows.length ] = {
        addColumns: true,
        columns: [{
          addSection: true,
          sections: [{
            isEditing: true,
            questions: []
          }]
        }]
      }


    // if (pageBreak == -1) {
    //   // obj.rows[obj.rows.length - 1].pageProperties = {}
    //   obj.rows[obj.rows.length - 1].pageProperties = obj.rows[obj.rows.length - 1].pageProperties ? { ...obj.rows[obj.rows.length - 1].pageProperties } : {}
    //   obj.rows[obj.rows.length - 1].pageProperties.pageBreak = true
    //   obj.rows[obj.rows.length - 1].pageProperties.pageNumber = 1;

    //   obj.rows[obj.rows.length] = {
    //     addColumns: true,
    //     columns: [{
    //       addSection: true,
    //       sections: [{
    //         isEditing: true,
    //         questions: []
    //       }]
    //     }]
    //   }
    // } else {
    //   let item = obj.rows[pageBreak]
    //   obj.rows[pageBreak + 1].pageProperties = obj.rows[pageBreak + 1].pageProperties ? { ...obj.rows[pageBreak + 1].pageProperties } : {}
    //   obj.rows[pageBreak + 1].pageProperties.pageBreak = true
    //   // obj.rows[pageBreak + 1].pageProperties.pageNumber = item.pageProperties.pageNumber + 1;

    //   obj.rows[pageBreak + 1 + 1] = {
    //     addColumns: true,
    //     columns: [{
    //       addSection: true,
    //       sections: [{
    //         isEditing: true,
    //         questions: []
    //       }]
    //     }]
    //   }
    // }
    this.templateObj = obj;
  }

  addPageFooterToggle() {
    let obj = { ...this.templateObj };
    let footerPresent = obj.rows.find((a) => a && a != null && a.pageProperties && a.pageProperties.isFooter == true)
    if (!footerPresent) {
      obj.rows.map((rowItem) => {
        rowItem.addColumns = false;
        rowItem.columns.map((colItem) => {
          colItem.addSection = false;
          colItem.sections.map((a) => {
            a.isEditing = false;
          })
        })
      })
      obj.rows.splice(0, 0, {
        pageProperties: {
          isFooter: true
        },
        addColumns: true,
        columns: [{
          addSection: true,
          sections: [{
            isEditing: true,
            questions: []
          }]
        }]
      })

    } else {

      let footerPresent = obj.rows.findIndex((a) => a && a != null && a.pageProperties && a.pageProperties.isFooter == true);
      if (footerPresent != -1) {
        obj.rows.splice(footerPresent, 1);
      }
    }
    this.templateObj = obj;
  }

  addPageHeaderToggle() {
    let obj = { ...this.templateObj };
    let headerPresent = obj.rows.find((a) => a && a != null && a.pageProperties && a.pageProperties.isHeader == true)
    if (!headerPresent) {
      obj.rows.map((rowItem) => {
        rowItem.addColumns = false;
        rowItem.columns.map((colItem) => {
          colItem.addSection = false;
          colItem.sections.map((a) => {
            a.isEditing = false;
          })
        })
      })
      obj.rows.splice(0, 0, {
        pageProperties: {
          isHeader: true
        },
        addColumns: true,
        columns: [{
          addSection: true,
          sections: [{
            isEditing: true,
            questions: []
          }]
        }]
      })

    } else {

      let headerPresent = obj.rows.findIndex((a) => a && a != null && a.pageProperties && a.pageProperties.isHeader == true);
      if (headerPresent != -1) {
        obj.rows.splice(headerPresent, 1);
        // message.warning('Header is deleted', () => {
        //   // console.log('closed')
        // })
      }
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {Object} data - Object of element to be added to template object
 */
  addElement(data) {
    let elementObj = { ...data }
    delete elementObj['index']

    let obj = { ...this.templateObj };
    if (data.index) {

      let rows = obj.rows;
      let rowIndex = data.index.rowIndex;
      let colIndex = data.index.colIndex;
      let secIndex = data.index.secIndex;
      let quesIndex = data.index.self;

      let rowItem = rows[rowIndex];

      if (rowItem) {

        let columns = rowItem.columns;
        let columnItem = columns[colIndex];
        if (columnItem) {
          let sectionItem = columnItem.sections[secIndex];
          if (sectionItem) {
            let quesArr = sectionItem.questions;
            let ques = quesArr[quesIndex];

            if (ques && ques.linkedQuestions) {
            } else {
              quesArr[quesIndex] = elementObj;

            }

          }
        }
      }
    } else {
      obj.rows.map((rowItem) => {
        rowItem.columns.map((colItem) => {
          colItem.sections.map((a) => {
            if (a.isEditing == true) {
              // if (a.questions.length == 0) {
              //   a.questions.push(data)
              //   return
              // }
              // let flag = true;

              // const loopQuestions = (ques) => {
              //   if (ques && ques != null) {
              //     if (ques.isLinking == true && !ques.linkedQuestions) {
              //       ques.linkedQuestions = [data]
              //       return false
              //     } else if (ques.isLinking == true && ques.linkedQuestions) {
              //       ques.linkedQuestions.push(data)
              //       return false
              //     } else if (ques.isLinking == false && ques.linkedQuestions && ques.linkedQuestions.length > 0) {
              //       let flag2 = true;
              //       ques.linkedQuestions.map((param) => {
              //         let flag1 = loopQuestions(param)

              //         if (flag1 != undefined) {
              //           flag2 = flag1;
              //         }
              //       })
              //       return flag2
              //     }

              //     if (ques.isLinking == true) {
              //       return false
              //     }
              //   }
              // }
              // a.questions.map((ques) => {
              //   // let flag1 = loopQuestions(ques)

              //   // if (flag1 != undefined) {
              //   //   flag = flag1;
              //   // }
              // })

              // if (flag == true) {
              a.questions.push(elementObj)
              // }
            }

          })
        })
      })

    }




    this.templateObj = obj;

  }

/**
 * 
 * @param {Array} data - Subtemplate data to be added
 * @param {Number} index - Index at which subtemplate should be added
 */
  addSubtemplate=(data, index)=>{
    let flag = false;
    let obj = { ...this.templateObj };
    obj.rows.map((rowItem) => {
      rowItem.columns.map((colItem) => {
        colItem.sections.map((a) => {
          if (a.isEditing == true) {
            // if (a.questions.length == 0) {
            if (index != undefined || index != null) {
              data.forEach((d)=>{
                a.questions.splice(index, 0, d)
              })
            } else {
              data.forEach((d)=>{
                a.questions.push(d)
              })
            }
            flag = true;
            message.success('Subtemplate added successfully !!')
            return
          }
        })
      })
    })
    if (flag == false) {
      message.warning('Please select section')
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {Object} data - Object of question to be added
 * @param {Number} index - Index at which the question will be added
 */
  addQuestion(data, index) {
    let flag = false;
    let obj = { ...this.templateObj };
    obj.rows.map((rowItem) => {
      rowItem.columns.map((colItem) => {
        colItem.sections.map((a) => {
          if (a.isEditing == true) {
            // if (a.questions.length == 0) {
            if (index != undefined || index != null) {
              a.questions.splice(index, 0, data)
            } else {
           
              a.questions.push(data)
            }
            flag = true;
            message.success('Question added successfully !!')
            return
          }
        })
      })
    })
    if (flag == false) {
      message.warning('Please select section')
    }
    this.templateObj = obj;
  }

/**
 * 
 * @param {Object} quesItem - Object of question to be updated
 */
  updateQuestion(quesItem) {

    let slugValue = quesItem.slugValue;
    let obj = { ...this.templateObj };
    let rows = obj.rows;


    let rowIndex = quesItem.index.rowIndex;
    let colIndex = quesItem.index.colIndex;
    let secIndex = quesItem.index.secIndex;
    let quesIndex = quesItem.index.self;

    let rowItem = rows[rowIndex];

    if (rowItem) {

      let columns = rowItem.columns;
      let columnItem = columns[colIndex];
      if (columnItem) {
        let sectionItem = columnItem.sections[secIndex];
        if (sectionItem) {
          let quesArr = sectionItem.questions;
          let ques = quesArr[quesIndex];

          if (ques && ques.linkedQuestions) {
          } else {
            quesArr[quesIndex] = quesItem;

          }

        }
      }
    }


    if (quesItem.changesOptions) {
      obj.rows.map((rowItem) => {
        rowItem.columns.map((colItem) => {
          colItem.sections.map((item) => {
            item.questions && item.questions.map((a, index) => {
              // if(a.slugValue == quesItem.slugValue){

              // }
              if (a && a != null && a.conditions) {

                let arr = a.conditions.map((c) => {
                  if (c.val && (c.val.quesSlug == quesItem.slugValue)) {
                    let item = quesItem.changesOptions.find((m) => m.original == c.val.response)
                    if (item) {
                      // let patt = new RegExp(item.original, "g");
                      c.title.replace('How', '*')
                      console.log(c.title)

                      c.val.response = item.new
                      c.val.summary = item.new
                    }
                  }

                  if (c.value && (c.value.quesSlug == quesItem.slugValue)) {
                    let item = quesItem.changesOptions.find((m) => m.original == c.value.response)

                    if (item) {
                      // let patt = new RegExp(item.original, "g");
                      c.title.replace('How', '*')

                      console.log(c.title)

                      c.value.response = item.new
                      c.value.summary = item.new
                    }
                  }

                  return c
                })

                a.conditions = arr
              }
            })
          })
        })
      })
    }


    this.templateObj = obj;
  }

/**
 * 
 * @param {Object} selectedQues - Object of selected question
 * @param {Array} conditions - Conditions to be attached to question
 */
  b(selectedQues, conditions) {
    let obj = { ...this.templateObj };
    const loopQuestions = (a) => {
      if (a && a != null) {

        if (a.uId == selectedQues.uId && JSON.stringify(a.index) == JSON.stringify(selectedQues.index)) {

          // let conditions = getPrepedConditions();
          a.conditions = conditions
        } else if (a.linkedQuestions && a.linkedQuestions.length > 0) {

          a.linkedQuestions.map((x) => {
            loopQuestions(x)
          })
        }
      }
    }

    obj.rows.map((rowItem, rowIndex) => {
      rowItem.columns.map((colItem, colIndex) => {
        colItem.sections.map((item, secIndex) => {
          item.questions && item.questions.map((a, i) => {
            a.index = {
              self: i,
              secIndex: secIndex,
              colIndex: colIndex,
              rowIndex: rowIndex
            }

            loopQuestions(a)
          })
        })
      })
    })
    this.templateObj = obj;
  }

/**
 * 
 * @param {Object} selectedQues - Object of selected question
 * @param {Array} conditions - Conditions to be attached to selected question
 */
  bindConditionsToQues(selectedQues, conditions) {

    let obj = { ...this.templateObj };
    let rows = obj.rows;

    const loopQuestions = (a, index, arr) => {

      if (a && a != null) {
        if (a.slugValue == selectedQues.slugValue) {
          a.conditions = conditions
        } else {
          if (a.linkedQuestions && a.linkedQuestions.length > 0) {
            a.linkedQuestions.map((param, m) => {
              loopQuestions(param, m, a.linkedQuestions)
            })
          }
        }
      }
    }

    let rowIndex = selectedQues.index.rowIndex;
    let colIndex = selectedQues.index.colIndex;
    let secIndex = selectedQues.index.secIndex;
    let quesIndex = selectedQues.index.self;
    let linkedIndex = undefined;

    let rowItem = rows[rowIndex];
    if (rowItem) {

      let columns = rowItem.columns;
      let columnItem = columns[colIndex];
      if (columnItem) {
        let sectionItem = columnItem.sections[secIndex];
        if (sectionItem) {
          let quesArr = sectionItem.questions;
          let ques = quesArr[quesIndex];
          ques.conditions = conditions
        }
      }
    }

    this.templateObj = obj;

  }


/**
 * 
 * @param {Number} rowIndex - Parent row index of selected question
 * @param {Number} colIndex - Parent column index of selected question
 * @param {Number} secIndex - Parent section index of selected question
 * @param {Number} quesIndex - Parent question index of selected question
 * @param {Number} linkedIndex - Deprecated
 * @param {Object} quesItem - Object of question to be deleting conditions
 */

  deleteQuestionConditions(rowIndex, colIndex, secIndex, quesIndex, linkedIndex, quesItem) {
    let obj = { ...this.templateObj };
    let rows = obj.rows;

    const loopQuestions = (a, index, arr) => {

      if (a && a != null) {
        if (a.slugValue == quesItem.slugValue) {
          arr.splice(index, 1)
        } else {
          if (a.linkedQuestions && a.linkedQuestions.length > 0) {
            a.linkedQuestions.map((param, m) => {
              loopQuestions(param, m, a.linkedQuestions)
            })
          }
        }
      }
    }

    let rowItem = rows[rowIndex];
    if (rowItem) {

      let columns = rowItem.columns;
      let columnItem = columns[colIndex];
      if (columnItem) {
        let sectionItem = columnItem.sections[secIndex];
        if (sectionItem) {
          let quesArr = sectionItem.questions;

          if (linkedIndex == undefined) {
            let quI = quesArr[quesIndex]
            delete quI['conditions']
          } else {

            let ques = quesArr[quesIndex];
            if (ques && ques.linkedQuestions) {
              let aa = ques.linkedQuestions;
              ques.linkedQuestions.map((param, m) => {
                loopQuestions(param, m, aa)
              })

            }

          }
        }
      }
    }
    this.templateObj = obj;
  }

  resetTemplate() {
    this.templateObj = {
      // title: 'Form title',
      // description: 'form description',
      active: true,
      rows: [{
        addColumns: true,
        columns: [{
          addSection: true,
          sections: [{
            isEditing: true,
            // sectionTitle:'Section-1',
            questions: []
          }]
        }]
      }]
    }
  }

}


export default Template;